import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { demandCustomElement } from '@umbraco-ui/uui-base/lib/utils';
import { UUIButtonElement } from '@umbraco-ui/uui-button/lib';
import { UUIEvent } from '@umbraco-ui/uui-base/lib/events';

class UUICopyTextEvent extends UUIEvent {
  constructor() {
    super(...arguments);
    /**
     * The text content that is about to be copied to the clipboard
     */
    this.text = null;
  }
  static {
    this.COPIED = "copied";
  }
  static {
    this.COPYING = "copying";
  }
}

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var _animationTimer, _onClick;
let UUIButtonCopyTextElement = class extends UUIButtonElement {
  constructor() {
    super();
    this.text = "";
    this.copyFrom = "";
    this.animationStateDelay = 250;
    __privateAdd(this, _animationTimer);
    __privateAdd(this, _onClick, async () => {
      this.state = "waiting";
      let valueToCopy = this.text;
      if (this.copyFrom) {
        const el = document.getElementById(this.copyFrom);
        if (el) {
          if ("value" in el) {
            valueToCopy = el.value;
          } else {
            valueToCopy = el.textContent ?? el.innerText ?? "";
          }
        } else {
          console.error(`Element ID ${this.copyFrom} not found to copy from`);
          this.state = "failed";
          return;
        }
      }
      const beforeCopyEv = new UUICopyTextEvent(UUICopyTextEvent.COPYING);
      beforeCopyEv.text = valueToCopy;
      this.dispatchEvent(beforeCopyEv);
      if (beforeCopyEv.text != null) {
        valueToCopy = beforeCopyEv.text;
      }
      try {
        await navigator.clipboard.writeText(valueToCopy);
        const copiedEv = new UUICopyTextEvent(UUICopyTextEvent.COPIED);
        copiedEv.text = valueToCopy;
        this.dispatchEvent(copiedEv);
        __privateSet(this, _animationTimer, setTimeout(() => {
          this.state = "success";
        }, this.animationStateDelay));
      } catch (err) {
        this.state = "failed";
        console.error("Error copying to clipboard", err);
      }
    });
    demandCustomElement(this, "uui-icon");
    this.addEventListener("click", __privateGet(this, _onClick));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (__privateGet(this, _animationTimer)) {
      clearTimeout(__privateGet(this, _animationTimer));
    }
  }
  renderLabel() {
    return html`
      <slot class="label">
        <uui-icon name="copy"></uui-icon>
      </slot>
    `;
  }
};
_animationTimer = new WeakMap();
_onClick = new WeakMap();
UUIButtonCopyTextElement.styles = UUIButtonElement.styles;
__decorateClass([
  property({ type: String })
], UUIButtonCopyTextElement.prototype, "text", 2);
__decorateClass([
  property({ type: String, attribute: "copy-from" })
], UUIButtonCopyTextElement.prototype, "copyFrom", 2);
__decorateClass([
  property({ type: Number, attribute: "animation-state-delay" })
], UUIButtonCopyTextElement.prototype, "animationStateDelay", 2);
UUIButtonCopyTextElement = __decorateClass([
  defineElement("uui-button-copy-text")
], UUIButtonCopyTextElement);

export { UUIButtonCopyTextElement, UUICopyTextEvent };
